import React from "react";
import { Box, Typography, Grid, TextField, Button } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import Header from "../Homepage/Components/Header";
import axios from "axios";
import IMG from "./IMG.jpg"; // Importing the background image.


const ContactUs = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const name = formData.get("name");
    const email = formData.get("email");
    const message = formData.get("message");

    try {
      // Sending the form data to your backend API for AWS SES integration.
      await axios.post("https://app.stock101.org/contact", {
        name,
        email,
        message,
      });
      alert("Your message has been sent successfully! We’ll get back to you soon.");
    } catch (error) {
      console.error("Failed to send the message", error);
      alert("Failed to send the message. Please try again later.");
    }
  };

  return (
    <Box><Header />
    <Box
      sx={{
        backgroundColor: "",
      }}>
      {/* Header */}
      
      <Box
  sx={{
    marginTop: "32px",
    padding: "32px",
    borderRadius: "12px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  }}
>
  <Typography
    variant="h4"
    sx={{
      fontWeight: "bold",
      fontFamily: "'Work Sans', sans-serif",
      color: "#333",
      marginBottom: "16px",
      fontSize: "1.5rem",
    }}
  >
    CONTACT US
  </Typography>
  <Typography
    variant="body1"
    sx={{
      fontFamily: "'Work Sans', sans-serif",
      color: "#666",
      lineHeight: 1.8,
      fontSize: "1rem",
      marginBottom: "24px",
    }}
  >
    <strong>Stock101</strong> was born out of a passion for empowering investors to make profitable decisions with ease.  
    Our platform simplifies stock analysis by enabling effortless sorting and filtering of the stock market based on key technical indicators and custom parameters.  
    <br /><br />
    Stay ahead with our curated <strong>real-time news</strong>, including:  
    <br />
    <Typography
      variant="body1"
      sx={{
        marginTop: "8px",
        color: "#333",
        fontFamily: "'Work Sans', sans-serif",
        fontSize: "1rem",
      }}
    >
      - Ranked news to highlight the most impactful stories.
    </Typography>
    <Typography
      variant="body1"
      sx={{
        marginTop: "8px",
        color: "#333",
        fontFamily: "'Work Sans', sans-serif",
        fontSize: "1rem",
      }}
    >
      - Price-target news tailored to your investment goals.
    </Typography>
    <Typography
      variant="body1"
      sx={{
        marginTop: "8px",
        color: "#333",
        fontFamily: "'Work Sans', sans-serif",
        fontSize: "1rem",
      }}
    >
      - Trending news for staying updated on market movements.
    </Typography>
  </Typography>
  <Typography
    variant="body2"
    sx={{
      fontStyle: "italic",
      fontFamily: "'Work Sans', sans-serif",
      color: "#999",
      marginBottom: "24px",
      fontSize: "0.95rem",
    }}
  >
    "Simplifying stock analysis to amplify your success. Insights amplified, investing simplified."
  </Typography>
  <Typography
    variant="body1"
    sx={{
      fontFamily: "'Work Sans', sans-serif",
      color: "#666",
      fontSize: "1rem",
      marginBottom: "16px",
    }}
  >
    <strong>Abraham George</strong>  
    <br />CEO, Stock101  
    <br />
    <a
      href="mailto:abrahamgeorge@stock101.org"
      style={{
        color: "#007bfc",
        textDecoration: "none",
      }}
    >
      abrahamgeorge@stock101.org
    </a>
  </Typography>
</Box>

<Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: "700px",
          margin: "auto",
          padding: "2rem",
          marginTop: "3rem",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
          zIndex: 2,
        }}
      >
        <Typography
          variant="h5"
          align="center"
          sx={{
            marginBottom: "1.5rem",
            fontWeight: 600,
          }}
        >
          Send Us a Message
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="name"
              label="Your Name"
              fullWidth
              variant="outlined"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="email"
              label="Your Email"
              fullWidth
              variant="outlined"
              type="email"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="message"
              label="Your Message"
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              required
            />
          </Grid>
        </Grid>

        <Box sx={{ textAlign: "center", marginTop: "1.5rem" }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            endIcon={<SendOutlinedIcon />}
            sx={{
              backgroundColor: "#007bfc",
              "&:hover": {
                backgroundColor: "#005bb5",
              },
            }}
          >
            Send Message
          </Button>
        </Box>
      </Box>

      {/* Footer Section */}
      <Box
        sx={{
          textAlign: "center",
          padding: "2rem 0",
          marginTop: "6rem",
          color: "#999",
        }}
      >
        <Typography>
       
         
        </Typography>
        <Typography sx={{ mt: 2 }}>
          For support, email us at:{" "}
          <a
            href="mailto:support@stock101.org"
            style={{ color: "#42a5f5", textDecoration: "none" }}
          >
            support@stock101.org
          </a>
        </Typography>
      </Box>
    </Box>
    </Box>
  );
};

export default ContactUs;
